/* eslint-disable no-param-reassign */
import { FETCH_STATUSES } from 'utils/fetchStatusUtils';

export default function createResourceSlice(options) {
  const { resource, repository } = options;

  return {
    initialState: {
      [resource]: {
        creatingStatus: FETCH_STATUSES.idle,
        errors: null,
      },
    },
    reducers: {
      createResourceStart(state) {
        state[resource].creatingStatus = FETCH_STATUSES.pending;
        state[resource].errors = null;
      },
      createResourceSuccess(state) {
        state[resource].creatingStatus = FETCH_STATUSES.fulfilled;
      },
      createResourceFail(state, { payload: { errors } }) {
        state[resource].creatingStatus = FETCH_STATUSES.failed;
        state[resource].errors = errors;
      },
    },
    actionCreators(restDispatch) {
      return {
        createResource: params => {
          restDispatch('createResourceStart');

          return repository
            .create(params)
            .then(({ data }) => restDispatch('createResourceSuccess', data))
            .catch(errors => {
              restDispatch('createResourceFail', { errors });
              throw errors;
            });
        },
      };
    },
    abstractSelector: state => ({
      resource: state[resource],
    }),
  };
}
